import React from 'react'

const Context = React.createContext({
  keyboardNavigator: {},
  getScrollerAPI: () => {},
})

export default Context
